var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('collaboration-certificate',{attrs:{"flat":true,"certificate":_vm.certificate,"show-download-button":false}})
}
var staticRenderFns = []

export { render, staticRenderFns }